export default "__VITE_ASSET__x4ROIHqg__"